import 'css-chunksrc/client/scenes/projectCreationFromModel/modelSelection/projectModel/styles.scss';export default {
  "projectModel": "_projectModel_1rfy8_1",
  "name": "_name_1rfy8_10",
  "button": "_button_1rfy8_15"
};